import { Children, ReactElement, ReactNode, isValidElement } from "react";
import "./PerformanceTile.scss";
import LeafTileDivider from "../../../../common/leaf/LeafTileDivider/LeafTileDivider";

interface Props {
  children?: ReactNode;
  link?: string;
}

const PERFORMANCE_TILE_HEADER_ID = "__PERFORMANCE_TILE_HEADER__";

export const PerformanceTile = ({ children, link }: Props) => {
  const childrenArray = Children.toArray(children);

  let headerElement: ReactElement | null = null;
  const bodyElements: ReactNode[] = [];

  childrenArray.forEach((child) => {
    if (
      isValidElement(child) &&
      child.type &&
      typeof child.type === "function" &&
      (child.type as { __PERFORMANCE_TILE_ID?: string }).__PERFORMANCE_TILE_ID === PERFORMANCE_TILE_HEADER_ID
    ) {
      headerElement = child;
    } else {
      bodyElements.push(child);
    }
  });

  const headerProps = (headerElement as ReactElement<{ link?: string; labelLink?: string }> | null)?.props;
  const hasInteractiveHeader = !!(headerProps?.link || headerProps?.labelLink);

  const tileContent = (
    <>
      {headerElement}
      {bodyElements.length > 0 && (
        <>
          <div className="perf-tile__divider">
            <LeafTileDivider />
          </div>
          <div className="perf-tile__body">{bodyElements}</div>
        </>
      )}
    </>
  );

  if (link && bodyElements.length === 0) {
    return (
      <a href={link} className="perf-tile perf-tile--link">
        {tileContent}
      </a>
    );
  }

  return (
    <div className="perf-tile" {...(!hasInteractiveHeader ? { tabIndex: 0, role: "group" } : {})}>
      {tileContent}
    </div>
  );
};
